/**
 * Order and payment states, plus the allowed order-state transitions. Pure and dependency-free:
 * the collection config, its hooks and the admin client components all import it.
 */
export const statiOrdine = [
  { label: 'In attesa', value: 'in-attesa' },
  { label: 'Confermato', value: 'confermato' },
  { label: 'In lavorazione', value: 'in-lavorazione' },
  { label: 'Spedito', value: 'spedito' },
  { label: 'Completato', value: 'completato' },
  { label: 'Annullato', value: 'annullato' },
] as const

export const statiPagamento = [
  { label: 'Da pagare', value: 'da-pagare' },
  { label: 'Pagato', value: 'pagato' },
  { label: 'Rimborsato', value: 'rimborsato' },
] as const

export type StatoOrdine = (typeof statiOrdine)[number]['value']
export type StatoPagamento = (typeof statiPagamento)[number]['value']

/**
 * Where an order can go from each state. `completato` and `annullato` are final. Pickup orders
 * skip `spedito` (`confermato` / `in-lavorazione` → `completato`).
 */
export const transizioniStato: Record<StatoOrdine, readonly StatoOrdine[]> = {
  'in-attesa': ['confermato', 'in-lavorazione', 'annullato'],
  confermato: ['in-lavorazione', 'spedito', 'completato', 'annullato'],
  'in-lavorazione': ['spedito', 'completato', 'annullato'],
  spedito: ['completato'],
  completato: [],
  annullato: [],
}

const etichette: Record<string, string> = Object.fromEntries(
  [...statiOrdine, ...statiPagamento].map(({ label, value }) => [value, label]),
)

/** `'in-attesa'` → `'In attesa'`; unknown values are returned as they are. */
export const etichettaStato = (valore: string): string => etichette[valore] ?? valore

/** Staying in the same state is always allowed (saving other fields). */
export const transizioneAmmessa = (da: string, a: string): boolean =>
  da === a || Boolean(transizioniStato[da as StatoOrdine]?.includes(a as StatoOrdine))
